import { useRef } from 'react'

type PropTypes = {
  onImageChange: (file: File) => void
  formElement: (ref: React.RefObject<HTMLInputElement>) => React.ReactNode
}

const ImageInput = ({ onImageChange, formElement }: PropTypes) => {
  const inputRef = useRef<HTMLInputElement>(null)

  return (
    <div>
      {formElement(inputRef)}

      <input
        ref={inputRef}
        type="file"
        className="hidden"
        accept="image/jpeg, image/png, image/gif, image/webp"
        onChange={(e) => {
          const file = e.target.files?.[0]

          if (file) {
            onImageChange(file)
          }
        }}
      />
    </div>
  )
}

export default ImageInput
